import { dataTransform } from '@nexio/emvio-util-app';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { transformMonthYearCell } from '../../utils/cell';
import StatementsListItem from './StatementsListItem/StatementsListItem';
import { fetchUrl, getStatements as fetchStatements } from './statementsActions';
import {
    getCount,
    getIsStatementsLoading,
    getPages,
    getStatements,
    getStatementsErrorMessage
} from './statementsEntity';
import Table from '../Table/Table';
import Actions from './Actions/Actions';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import { getCustomAccess } from '../Self/selfEntity';
import config from '../../config/config';
import InPageMerchantSelector from '../MerchantSelector/InPageMerchantSelector';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getSelf } from '../Self/selfEntity';

const defaultColumnsAndProps = [
    {
        accessor: 'merchantName',
        filterable: false,
        label: 'Merchant',
        minWidth: 150,
        show: true,
        sortable: false
    },
    {
        accessor: 'statementDate',
        Cell: transformMonthYearCell,
        transformData: dataTransform.dateTimezoneButHideTimezone,
        transformType: 'dateTimezoneButHideTimezone',
        defaultSortDesc: true,
        filterable: false,
        label: 'Date',
        minWidth: 135,
        show: true
    },
    {
        accessor: 'action',
        Cell: (props) => (<Actions statement={props.original} />),
        filterable: false,
        label: 'Action',
        minWidth: 60,
        show: true,
        sortable: false
    },
    {
        accessor: 'merchantId',
        filterable: false,
        label: 'Merchant ID',
        minWidth: 145,
        show: false
    }
];

export class Statements extends Component {
    static propTypes = {
        customAccess: PropTypes.any,
        self: PropTypes.any
    };

    render() {
        const dateKey = 'statementDate';

        let columnsAndProps = _.cloneDeep(defaultColumnsAndProps);
        if (!doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.pdf]: ['GET/v3/statement'] })) {
            columnsAndProps = columnsAndProps.filter((column) => column.accessor !== 'action');
        }

        return (
            <>
                {this.props.flags?.resellerPhase1 && this.props.self?.accountType === 'RESELLER' && <InPageMerchantSelector />}
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-statements-table"
                    dateKey={dateKey}
                    defaultColumnsAndProps={columnsAndProps}
                    defaultPageSize={12}
                    defaultSorted={[{
                        desc: true,
                        id: dateKey
                    }]}
                    fetchData={fetchStatements}
                    countSelector={getCount}
                    dataSelector={getStatements}
                    errorMessageSelector={getStatementsErrorMessage}
                    isDataLoadingSelector={getIsStatementsLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    ListItemComponent={StatementsListItem}
                    noDataText="No Statements Found"
                    shouldHideExport
                    hasNoCount={true}
                    shouldUseGlobalDate={false}
                    uniqueTableName="Statements"
                    alternatePicker="annual"
                    hidePageSizeSelect
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        customAccess: getCustomAccess(state),
        self: getSelf(state)
    };
}

export default withLDConsumer()(connect(mapStateToProps)(Statements));
